import { useLatestEntity } from '@domain-group/react-hooks'

import useDispatch from '@hooks/useDispatch'
import useSelector from '@hooks/useSelector'

import * as adAccountGroupAdAccountActions from '@redux/modules/adAccountGroupAdAccount'
import type {
  CreateAndLinkAdAccountsParams as CreateAndLinkParams,
} from '@redux/modules/adAccountGroupAdAccount'

import type { AppDispatch } from '@redux/store'
import type { DeleteParams } from '@redux/modules/types'
import type { AdAccountGroupAdAccountModel } from '@models/types'

type CreateAndLinkAdAccountParams = {
  createAndLinkParams: CreateAndLinkParams,
  dispatch: AppDispatch,
}

const createAndLinkAdAccounts = (params: CreateAndLinkAdAccountParams) => {
  const { createAndLinkParams, dispatch } = params
  const { createAndLinkAdAccounts: createAndLinkFn } = adAccountGroupAdAccountActions

  return dispatch(createAndLinkFn(createAndLinkParams))
}

type DeleteAdAccountGroupAdAccountParams = {
  adAccountGroupAdAccount: DeleteParams<AdAccountGroupAdAccountModel>,
  dispatch: AppDispatch,
}

const deleteAdAccountGroupAdAccount = (params: DeleteAdAccountGroupAdAccountParams) => {
  const { dispatch, adAccountGroupAdAccount } = params
  const { deleteAdAccountGroupAdAccount: deleteFn } = adAccountGroupAdAccountActions

  return dispatch(deleteFn(adAccountGroupAdAccount))
}

export const useRelations = (adAccountGroupAdAccount: Partial<AdAccountGroupAdAccountModel> = {}) => {
  const { adAccountGroupId, adAccountId } = adAccountGroupAdAccount

  const { adAccountGroups, adAccounts } = useSelector(reduxState => reduxState.entities)

  const adAccount = adAccountId && adAccounts[adAccountId] ? adAccounts[adAccountId] : {}
  const adAccountGroup = adAccountGroupId && adAccountGroups[adAccountGroupId] ? adAccountGroups[adAccountGroupId] : {}

  return {
    adAccount,
    adAccountGroup,
  }
}

function useAdAccountGroupAdAccount(initEntity: Partial<AdAccountGroupAdAccountModel> = {}) {
  const { entity: adAccountGroupAdAccount }: { entity: AdAccountGroupAdAccountModel } = useLatestEntity(initEntity, 'adAccountGroupAdAccounts')

  const dispatch = useDispatch()

  const {
    creating, deleting, loading,
  } = useSelector(reduxState => reduxState.adAccountGroupAdAccounts)

  return {
    adAccountGroupAdAccount,
    callbacks: {
      createAndLinkAdAccounts: (createAndLinkParams: CreateAndLinkParams) => createAndLinkAdAccounts({ createAndLinkParams, dispatch }),
      deleteAdAccountGroupAdAccount: () => deleteAdAccountGroupAdAccount({ adAccountGroupAdAccount, dispatch }),
    },
    creating,
    deleting,
    loading,
  }
}

export default useAdAccountGroupAdAccount
